import Vue from 'vue'
import { MazPhoneNumberInput } from 'maz-ui'

Vue.use(MazPhoneNumberInput)
